export default {
  path: "/password-recovery",
  name: "password-recovery.index",
  component: () => import("@/views/Login/PasswordRecovery/Index.vue"),
};
